<app-dialog-header [title]="'general.api_email_send_via'"></app-dialog-header>
<!-- INFO SECTION -->
<div class="dialog-info">
  <div class="flex">
    <div class="label-value bottom-spacer">
      <span class="label">
        {{(!isBookingReleased() ? 'general.api_invoice_order_confirmation_no' : 'general.api_invoice_invoice_no') | translate}}:
      </span>
      {{invoice?.invoiceNumber}}
    </div>
  </div>
</div>
<mat-dialog-content>
  <!-- CUSTOMER EMAILS -->
  <app-text-input class="max-width" *ngIf="!isBookingCancelledOrScrapped()" [type]="TextInputType.Email"
                  [label]="'general.api_customer_email'" [(value)]="emails" [required]="true"></app-text-input>
  <div *ngIf="!isBookingCancelledOrScrapped()" class="flex flex-grow flex-column-desktop">
    <div class="body-2 text-muted flex-row">
      <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
      {{(!isBookingReleased() ? 'general.api_email_field_note' : 'general.api_email_field_note_invoice') | translate}}
    </div>
    <div class="align-right desktop flex-row">
      <button *ngIf="isBookingActive() && isLinkPayValid"
              class="right-spacer"
              mat-stroked-button color="primary"
              [disabled]="!isLinkPayEmailValid()"
              (click)="sendLinkPayEmail()">{{'general.api_email_linkpay_send' | translate}}</button>
      <button *ngIf="!isBookingCancelledOrScrapped()" mat-flat-button color="primary" [disabled]="!isValid"
              (click)="sendEmail()">{{'general.api_email_send' | translate}}</button>
    </div>
  </div>
  <!-- SENT EMAILS -->
  <ng-template #emailTemplate let-item="item">{{item}}<br></ng-template>
  <div class="top-spacer">
    <div class="heading-3">{{ 'general.api_email_previous' | translate }}</div>
    <div class="table-container">
      <table *ngIf="!utilService.isMobile; else mobileTable"
             class="report-table bottom-spacer"
             attr.aria-describedby="{{'general.api_email_previous' | translate }}">
        <thead>
          <tr>
            <th id="email_type">{{ 'general.api_email_type' | translate }}</th>
            <th id="email_date">{{ 'general.api_email_date' | translate }}</th>
            <th id="email_to">{{ 'general.api_email' | translate }}</th>
            <th id="email_sender">{{ 'general.api_email_sender' | translate }}</th>
            <th id="email_status" class="align-right">{{ 'general.api_email_status' | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="sentEmails">
          <tr *ngFor="let sentEmail of sentEmails">
            <td>
              {{ 'general.api_email_type_' + sentEmail.type | translate }}
            </td>
            <td>
              {{ sentEmail.date | moment: {format: viewService.conf.dateTimeFormatWithSeconds, local: false, includeOffset: true} }}
            </td>
            <td>
              <app-show-more [maxItems]="2" [inputTemplate]="emailTemplate" [inputItems]="sentEmail.emails" [showCount]="true"></app-show-more>
            </td>
            <td>
              {{ sentEmail.userFullName }}
            </td>
            <td class="align-right">
              <span class="badge" [ngClass]="isProcessed(sentEmail) ? 'success' : 'warning'">
                {{ 'general.api_email_status_' + sentEmail.status | translate | uppercase }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #mobileTable>
        <div *ngIf="sentEmails">
          <hr class="no-margin">
          <div class="listing-block" *ngFor="let sentEmail of sentEmails">
            <div class="header-block flex space-between bottom-spacer">
              <div>
                <ng-container>
                  <div class="heading-5 no-margin text-base bold">
                    {{ sentEmail.date | moment: {format: viewService.conf.dateTimeFormatWithSeconds, local: false, includeOffset: true} }}
                  </div>
                  <span>{{ 'general.api_email_type_' + sentEmail.type | translate }}</span>
                </ng-container>
              </div>
              <div>
                <span class="badge" [ngClass]="isProcessed(sentEmail) ? 'success' : 'warning'">
                  {{ 'general.api_email_status_' + sentEmail.status | translate | uppercase }}
                </span>
              </div>
            </div>
            <table class="mobile-max-width">
              <tbody>
                <tr>
                  <td>
                    <span class="bold">{{ 'general.api_email_sender' | translate }}</span>
                  </td>
                  <td class="align-right">
                    {{ sentEmail.userFullName }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="bold">{{ 'general.api_email' | translate }}</span>
                  </td>
                  <td class="align-right">
                    <app-show-more [maxItems]="2" [inputTemplate]="emailTemplate" [inputItems]="sentEmail.emails" [showCount]="true"></app-show-more>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr class="no-margin top-spacer">
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
  <button mat-button mat-dialog-close>{{ 'general.api_general_close' | translate }}</button>
  <ng-container *ngIf="utilService.isMobile">
    <button *ngIf="isBookingActive() && isLinkPayValid" mat-stroked-button color="primary" [disabled]="!isLinkPayEmailValid()"
            (click)="sendLinkPayEmail()">{{'general.api_email_linkpay_send' | translate}}</button>
    <button *ngIf="!isBookingCancelledOrScrapped()" mat-flat-button color="primary" [disabled]="!isValid"
            (click)="sendEmail()">{{'general.api_email_send' | translate}}</button>
  </ng-container>
</ng-template>
